import moment from 'moment/moment';
import 'moment/locale/sv';
import 'moment/locale/es';

moment.locale(navigator.language);
